
import React, { FC } from "react";
import { useDeviceClassification } from "utils";
import { ImageGalleryMainDesktop } from "./components/ImageGalleryMainDesktop";
import { ImageGalleryMainMobile } from "./components/ImageGalleryMainMobile";

type ImageGalleryMainItemProps = {
  Alt: string;
  Src?: string;
  backgroundItem?: any;
};

type TImageGalleryMainProps = {
  large?: boolean;
  small?: boolean;
  images: ImageGalleryMainItemProps[];
  className?: string;
  width?: string;
  height?: string;
  noArrows?: boolean;
  ShowCaptions: boolean;
};

const _ImageGalleryMain: FC<TImageGalleryMainProps> = ({
  ShowCaptions,
  noArrows,
  large,
  small,
  images,
  className,
  width,
  height,
}) => {
  const { isDesktop } = useDeviceClassification();

  return (
    <div className="animateonscroll">
      {
        isDesktop
          ?
          <>
            <ImageGalleryMainDesktop
              ShowCaptions={ShowCaptions}
              large={large}
              small={small}
              images={images}
              className={className}
              width={width}
              height={height}
            />
          </>
          :
          <>
            <ImageGalleryMainMobile
              noArrows={noArrows}
              large={large}
              small={small}
              images={images}
              className={className}
              width={width}
              height={height}
              ShowCaptions={ShowCaptions}
            />
          </>
      }
    </div>
  );
};

export const ImageGalleryMain = React.memo(_ImageGalleryMain);
